// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1R-ME","col":"styles_col__2UETU"};